import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
  
import { error } from 'protractor';
 
import { environment } from 'src/environments/environment';
import { ProjetService } from 'src/app/service/projet.service';
import { StaffService } from 'src/app/service/staff.service';
import { ProspectService } from 'src/app/service/prospect.service';
import { FactureService } from 'src/app/service/facture.service';
 
import { Client } from 'src/app/entity/exhibitor';
import { Staff } from 'src/app/entity/Staff';
import { Projet } from 'src/app/entity/Projet';
import { Prospect } from 'src/app/entity/prospect';
import { ExhibitorDialogComponent } from 'src/app/shared/dialogs/exhibitor-dialog/exhibitor-dialog.component';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.scss']
})
export class CreateClientComponent implements OnInit {

  display: boolean = false;

  selectedClient:Client;
  selectedProspect:Prospect;
  idProspect:number;
  projectList:Projet[];
  usersList:Staff[]
  selectedUser:Staff;
  selectedProject:Projet;
  constructor(       private formBuilder: FormBuilder,
    private router: Router,
    private projetcService:ProjetService,
    private activatedRoute: ActivatedRoute,
    private staffService: StaffService,

    private prospectService: ProspectService,
    private factureService:FactureService,
    private exhibitorService: ExhibitorService,
    private dialog:MatDialog ) {
      this.selectedClient=new Client();

    this.activatedRoute.params.subscribe(params => {


      this.idProspect = + params['idProspect'];
    this.prospectService.getProspectErp(this.idProspect).subscribe(result=>{
 
        this.selectedProspect=result;
this.selectedUser=this.selectedProspect.utilisateurs;
this.selectedClient.prospectId=result;
 this.selectedUser= this.selectedClient.prospectId.utilisateurs;
 this.initClientSecteur(this.selectedProspect.secteur );
 
      })
   
  })
   }



  ngOnInit() {
this.projetcService.getProjectList().subscribe(result=>{
  this.projectList=result;
  this.projectList.forEach(element => {
  if(element.defaultProject)
  this.selectedProject=element;
});

})

this.staffService.findAllCommercial().subscribe(result=>{
  this.usersList=result;
 
})
  }

 

initClientSecteur(secteurStr: string){
 if(secteurStr)
this.prospectService.createSecteurIfNotExiste(secteurStr).subscribe(result=>{
  //console.log('secteurStrLog'+JSON.stringify(result));
  
  this.selectedProspect.secteurId=result;
  this.prospectService.saveProspectErp(this.selectedProspect).subscribe();
})
}
 
compareFn(v1: Staff, v2: Staff): boolean {
  return v1 && v2 ? v1.nom === v2.nom : v1 === v2;
}
compareFnProject(v1: Projet, v2: Projet): boolean {
  return v1 && v2 ? v1.numeroFiche === v2.numeroFiche : v1 === v2;
}
  createFichE(type:string){
 
    
    this.selectedClient.type=type;
 this.selectedClient.projetId=this.selectedProject;
this.selectedClient.concretiserPar=this.selectedUser.nom;
 
this.exhibitorService.addExhibitor(this.selectedClient).subscribe(result=>{

  this.router.navigateByUrl('/add-exhibitor/'+result.idClient);
},
error=>{
alert("Impossible de créer la fiche,\n Probable source d'erreur : Fiche existe dans le méme projet \n Contactez votre support")
});
  }
  createFich( ){
 //console.log("environment.serverNPAECAdresse "+environment.serverNPAECAdresse);
 
    window.open( environment.serverNPAECAdresse  , '_blank' );
  
  }
  createFichCOE(exposantP:Client ){
 
    
    this.selectedClient.type="C";
 this.selectedClient.projetId=this.selectedProject;
this.selectedClient.concretiserPar=this.selectedUser.nom;
 
this.exhibitorService.addCoExhibitor(exposantP.idClient,this.selectedClient).subscribe(result=>{
  window.open( environment.serverNPAECAdresse  , '_blank' ); },
 
 
error=>{
alert("Impossible de créer la fiche,\n Probable source d'erreur : Fiche existe dans le méme projet \n Contactez votre support")
});
  }





  CoExhibitor( ): void {
    // Create configuration for the dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '200px';
    dialogConfig.width = '400px';
    dialogConfig.data = {
        title: `Co-Exposant  ${this.selectedClient.prospectId.raisonSocial} `,
        message: 'Are you sure?'
    };

    const dialogRef = this.dialog.open(ExhibitorDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
        if (result) {
       let   exhibitor:Client=result;
       this.createFichCOE(exhibitor)
 
         
        }
    });
}


}
 